import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import LoginPage from "./pages/LoginPage";
import ModelerPage from "./pages/ModelerPage";
import AdminPage from "./pages/AdminPage";
import StrategiesPage from "./pages/StrategiesPage";
import EmployeesPage from "./pages/EmployeesPage";
import MoodTrendPage from "./pages/MoodTrendPage";
import LoadOverviewPage from "./pages/LoadOverviewPage";
import PvpPage from "./pages/PvpPage";
import PvpMeasurementsPage from "./pages/PvpMeasurementsPage";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center text-zinc-500 text-sm tracking-widest uppercase">
        Laden…
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/"
              element={
                <Protected>
                  <ModelerPage />
                </Protected>
              }
            />
            <Route
              path="/strategies"
              element={
                <Protected>
                  <StrategiesPage />
                </Protected>
              }
            />
            <Route
              path="/employees"
              element={
                <Protected>
                  <EmployeesPage />
                </Protected>
              }
            />
            <Route
              path="/belasting"
              element={
                <Protected>
                  <LoadOverviewPage />
                </Protected>
              }
            />
            <Route
              path="/stemming"
              element={
                <Protected>
                  <MoodTrendPage />
                </Protected>
              }
            />
            <Route
              path="/pvp/:id"
              element={
                <Protected>
                  <PvpPage />
                </Protected>
              }
            />
            <Route
              path="/pvp/:id/metingen"
              element={
                <Protected>
                  <PvpMeasurementsPage />
                </Protected>
              }
            />
            <Route
              path="/admin"
              element={
                <Protected>
                  <AdminPage />
                </Protected>
              }
            />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
